const COPYRIGHT = `© ${new Date().getFullYear()} Artem Morozov pr Računarsko programiranje Novi Sad`
    + ` · PIB 113974458 · MB 67228758`
    + ` · Bulevar Cara Lazara 44 L41, 21000 Novi Sad, Serbia`
    + ` · artem@artembo.com · No cookies`;

export default COPYRIGHT;
